'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';
import { Typography } from '@/shared/ui/atoms';
import * as S from './styles';

const MobileCategoryGridCard = () => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const checkImage = `${baseImageUrl}/medicontents/landing/category-check.png`;
  const checkedImage = `${baseImageUrl}/medicontents/landing/category-checked.png`;
  const categoryList = [
    [
      { text: ['키워드 중심 반복형콘텐츠 생산', '전략없는 콘텐츠'], highlightText: '' },
      { text: ['\n설계 콘텐츠'], highlightText: '의료 + SEO+ 법률 ' }
    ],
    [
      { text: ['신뢰 낮음', '전달력 부족'], highlightText: '' },
      { text: [`설계`], highlightText: '환자 공감 ' }
    ],
    [
      { text: ['의료법 대응 위험\n불안정'], highlightText: '' },
      { text: ['안전 구조'], highlightText: '의료법 반영 ' }
    ],
    [
      { text: ['낮은 매몰비용', '인건비 낭비·시간 낭비'], highlightText: '' },
      { text: [''], highlightText: '합리적 비용 ' }
    ],
    [
      { text: ['검색 노출 안됨'], highlightText: '' },
      { text: ['되는 결과'], highlightText: '상담으로 연결' }
    ]
  ];

  return (
    <motion.div
      initial={{ y: 55, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.7, ease: 'easeOut', delay: 0 }}
      className={S.motionCol}
    >
      <div className={S.topRow}>
        <div className={S.cardFactory}>
          <Typography className={S.labelFactory}>공장 블로그 / 병원 내부 작성</Typography>
          <div className={S.imageWrapFactory}>
            <Image src={`${baseImageUrl}/medicontents/landing/category01.png`} alt="공장 블로그/병원 내부 작성" fill sizes="100vw" />
          </div>
        </div>
        <div className={S.cardMedi}>
          <Typography className={S.labelMedi}>메디컨텐츠</Typography>
          <div className={S.imageWrapMedi}>
            <Image src={`${baseImageUrl}/medicontents/landing/category03.png`} alt="메디컨텐츠" fill sizes="100vw" />
          </div>
        </div>
      </div>
      {categoryList.map((category, index) => (
        <div key={`category-list-${index}`} className={S.categoryRow}>
          {category.map((card, i) => {
            const isMedi = i === 1;
            return (
              <div key={`category-grid-${i}`} className={isMedi ? S.gridCellMedi : S.gridCellFactory}>
                {card.text.map((text, j) => (
                  <div key={`category-grid-${j}`} className={S.rowInner}>
                    <div className={S.checkIcon}>
                      <Image src={isMedi ? checkedImage : checkImage} alt="category-grid-1" fill sizes="100vw" className={S.checkIconImg} />
                    </div>
                    <Typography className={`${S.cellTypography} ${isMedi ? S.cellTypographyMedi : S.cellTypographyFactory}`}>
                      <span className={S.highlight}>{card.highlightText}</span>
                      {text}
                    </Typography>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      ))}
    </motion.div>
  );
};

export default MobileCategoryGridCard;
